<template>
<v-container fluid fill-height>
    <absenceList :attendanceMemberID="attendanceMemberID" :attendanceID="attendanceID" :editMode="editMode" />
</v-container>
</template>

<script>
import absenceList from "@/components/plants/team/attendanceMemberAbsencesList.vue"

export default {
    components: {
        absenceList: absenceList
    },
    data() {
        return {
            loading: false,
            error: null,
            submitError: null,
            submitLoading: false,
        }
    },
    computed: {
        attendanceMemberID() {
            const array = this.$route.params.attendanceAndMemberID.split('-');
            return parseInt(array[0]);
        },
        attendanceID() {
            const array = this.$route.params.attendanceAndMemberID.split('-');
            return parseInt(array[1]);
        },
        editMode() {
            const array = this.$route.params.attendanceAndMemberID.split('-');
            return array[2] === "True" ? false : true;
        }
    },
    async created() {
        //empty
    }
}
</script>